import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../configHelper';

@Injectable({
   providedIn: 'root'
})
export class RawResultBatchDataService {

   constructor(private httpClient: HttpClient, private configService: ConfigService) {
   }

   public getList(start, count, sortBy, sortDirection, gridFilters) {
     let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RawResultBatch/GetList?start=${start}&length=${count}&sortBy=${sortBy}&sortDirection=${sortDirection}&gridFilters=${JSON.stringify(gridFilters)}`;
      return this.httpClient.get(url);
  }
   public getBatchById(batchId) {
     let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RawResultBatch/GetBatchById?batchId=${batchId}`;
     return this.httpClient.get(url);
   }


  public getResults(batchId, search) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RawResultBatch/GetResults?batchId=${batchId}&search=${search}`;
    return this.httpClient.get(url);
  }

  public getResultsPartial(batchId, search, start, size) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RawResultBatch/GetResultsPartial?batchId=${batchId}&search=${search}&start=${start}&size=${size}`;
    return this.httpClient.get(url);
  }

  public getAccession(batchId, accession) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RawResultBatch/GetAccession?batchId=${batchId}&accession=${accession}`;
    return this.httpClient.get(url);
  }

  public saveResults(dto) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RawResultBatch/Results`;
    return this.httpClient.post(url, dto);
  }

  public saveAccessionResult(dto) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RawResultBatch/AccessionResult`;
    return this.httpClient.post(url, dto);
  }

  public saveAssayResult(dto) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RawResultBatch/AssayResult`;
    return this.httpClient.post(url, dto);
  }

  public signOffResult(dto) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RawResultBatch/SignOffAccession`;
    return this.httpClient.post(url, dto);
  }

  public signOffBatch(dto) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RawResultBatch/SignOffBatch`;
    return this.httpClient.post(url, dto);
  }

  public deleteBatch(batchId) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RawResultBatch/DeleteBatch`;
    return this.httpClient.post(url, batchId);
  }

  public getReport(batchId, resultId) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RawResultBatch/Report?batchId=${batchId}&resultId=${resultId}`;

    const httpOptions = {
      'responseType': 'arraybuffer' as 'json'
      //'responseType'  : 'blob' as 'json'        //This also worked
    };

    return this.httpClient.get<any>(url, httpOptions);
  }
}
